import { useEffect, useRef } from 'react';

const useLeaveHandler = (callback) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      callbackRef.current?.(event);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    return () => {
      callbackRef.current?.();
    };
  }, []);
};

export default useLeaveHandler;
